import React from "react";
import { Box } from "@mui/material";
import AppointmentsTable from "./AppointmentsTable.jsx";
const Appointments = ({ patient }) => {
  return (
    <Box>
      <AppointmentsTable patient={patient} />
    </Box>
  );
};

export default Appointments;
